import { sendNotificationRequestSchema } from "@/constants/zod-schemas";
import { useSendNotification } from "@/hooks/query-hooks/useAuth";
import { Button, Divider, Flex, Form, Input, Segmented } from "antd";
import { Helmet } from 'react-helmet-async';
import { AnimatedComponent, PageTitle } from "../common";

enum NotiType {
	IN_APP = "IN_APP",
	NOTICE = "NOTICE",
}

export function SendNotification() {
	const [form] = Form.useForm();

	const { mutate, isLoading } = useSendNotification();
	const onFinish = (values: SendNotificationRequest) => {
		const payload = sendNotificationRequestSchema.parse(values);
		mutate(payload, {
			onSuccess: () => {
				form.resetFields();
			},
		});
	};

	return (
		<AnimatedComponent>
			<Helmet>
				<title> Notification ပို့ရန် </title>
			</Helmet>
			<PageTitle>
				Send Notification
			</PageTitle>
			<Divider />
			<Form
				layout="vertical"
				form={form}
				onFinish={onFinish}
				className="max-w-xl mx-auto !p-6 rounded shadow"
			>
				<Form.Item name={"type"} initialValue={NotiType.NOTICE}>
					<Segmented
						options={[
							{
								label: "Push Notification",
								value: NotiType.NOTICE,
							},
							{
								label: "In App Notification",
								value: NotiType.IN_APP,
							},
						]}
						size="large"
						block
					/>
				</Form.Item>
				<Form.Item
					name={"title"}
					label={"Title"}
					rules={[
						{
							required: true,
							message: "Required!",
						},
					]}
				>
					<Input size="large" placeholder="eg: Title" />
				</Form.Item>
				<Form.Item
					name={"body"}
					label={"Message"}
					rules={[
						{
							required: true,
							message: "Required!",
						},
					]}
				>
					<Input.TextArea
						size="large"
						autoSize={{ minRows: 5, maxRows: 10 }}
						classNames={{
							textarea: "text-sm!",
						}}
						placeholder="eg: Notification message. . . "
					/>
				</Form.Item>
				<Flex gap={12} justify="end" className="!mt-8">
					<Button
						type="text"
						onClick={() => form.resetFields()}
						size="large"
						disabled={isLoading}
					>
						Cancel
					</Button>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						className="bg-primary-gradient"
						shape="round"
						loading={isLoading}
					>
						Send
					</Button>
				</Flex>
			</Form>
		</AnimatedComponent>
	);
}
